import { Checkbox } from "antd";
import "firebase/compat/firestore";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import GeneralButton from "../../components/button/GeneralButton";
import FormInput from "../../components/formInput/FormInput";
import ImageUpload from "../../components/imageUpload/ImageUpload";
import useProfileHook from "./customHooks/useProfileHook";
import { FiUser, FiMail, FiPhone, FiMapPin, FiShield, FiInfo } from "react-icons/fi";

const UserProfilePage = () => {
    const {
        handleUserUpdate,
        userData,
        setUserData,
        handleImageUpload,
        permissions,
        handlePermissionChange,
        user,
    } = useProfileHook();

    return (
        <div className="profile-container bg-light min-vh-100">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={11}>
                        {/* Profile Header & Banner */}
                        <div className="profile-card mb-4 shadow-sm">
                            <div className="profile-header-banner"></div>
                            <div className="px-4 pb-4">
                                <div className="profile-avatar-wrapper text-center">
                                    <div className="avatar-container">
                                        <ImageUpload
                                            itemImage={userData?.profileImage}
                                            handleImageUpload={handleImageUpload}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <h2 className="fw-bold mb-0 text-dark">{userData?.username || "Admin User"}</h2>
                                        <p className="text-primary fw-medium">{user?.role || "Administrator"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Row className="gy-4">
                            {/* Right Side: Edit Details & Permissions */}
                            <Col lg={12}>
                                <Card className="profile-card shadow-sm">
                                    <CardBody className="p-4">
                                        <h5 className="section-title">
                                            <FiUser className="me-2" /> Personal Details
                                        </h5>
                                        <Row className="gy-4">
                                            <Col md={6}>
                                                <FormInput
                                                    type="text"
                                                    label="Username"
                                                    placeholder="Enter username"
                                                    icon={<FiUser className="text-primary" />}
                                                    value={userData?.username}
                                                    handleChange={(e) =>
                                                        setUserData((prev) => ({
                                                            ...prev,
                                                            username: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <FormInput
                                                    type="email"
                                                    label="Email Address"
                                                    placeholder="Enter email"
                                                    icon={<FiMail className="text-primary" />}
                                                    value={userData?.email}
                                                    handleChange={(e) =>
                                                        setUserData((prev) => ({
                                                            ...prev,
                                                            email: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <FormInput
                                                    type="text"
                                                    label="Office Address"
                                                    placeholder="Enter address"
                                                    icon={<FiMapPin className="text-primary" />}
                                                    value={userData?.address}
                                                    handleChange={(e) =>
                                                        setUserData((prev) => ({
                                                            ...prev,
                                                            address: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <FormInput
                                                    type="number"
                                                    label="Phone Number"
                                                    placeholder="Enter phone number"
                                                    icon={<FiPhone className="text-primary" />}
                                                    value={userData?.phone}
                                                    handleChange={(e) =>
                                                        setUserData((prev) => ({
                                                            ...prev,
                                                            phone: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        {/* Permissions Section */}
                                        {(user?.role === "Super-admin") && (
                                            <div className="mt-5">
                                                <h5 className="section-title">
                                                    <FiShield className="me-2" /> Access Permissions
                                                </h5>
                                                <p className="text-muted small mb-4">
                                                    Select the modules this administrative account has access to.
                                                </p>
                                                <Row className="gy-3">
                                                    {permissions?.map((perm, index) => (
                                                        <Col md={4} sm={6} key={index}>
                                                            <div className="permission-item bg-white">
                                                                <Checkbox
                                                                    className="w-100 fw-medium"
                                                                    checked={perm?.value}
                                                                    disabled={true}
                                                                >
                                                                    {perm?.name}
                                                                </Checkbox>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        )}


                                        {/* Action Button */}
                                        <div className="d-flex justify-content-end mt-5 pt-4 border-top">
                                            <GeneralButton
                                                title="Save Profiler Settings"
                                                className="save-btn text-white rounded-pill shadow"
                                                width="280px"
                                                handleClick={handleUserUpdate}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default UserProfilePage;

